/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * smoothScrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * スムーススクロール
 */
const smoothScrollTo = () => {
	const anchorLinks = document.querySelectorAll('a[href^="#"]');
	const anchorLinksArr = Array.prototype.slice.call(anchorLinks);

	anchorLinksArr.forEach((link) => {
		link.addEventListener("click", (e) => {
			e.preventDefault();
			const targetId = link.hash;
			const targetElement = document.querySelector(targetId);
			// const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
			let targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;

			// #navFixedが存在するとき
			// if (document.querySelector("#navFixed")) {
			// 	targetOffsetTop -= 200; // -200px
			// }
			window.scrollTo({
				top: targetOffsetTop,
				behavior: "smooth",
			});
		});
	});
};

export { smoothScrollTo };
